import { Injectable } from '@angular/core'

// Status and Transaction ID on the All Transactions search live for the
// browser session only: sessionStorage is dropped when the browser closes, and
// logout / the login screen remove it explicitly.
const TRANSACTION_SESSION_FILTERS_KEY = 'transactionSessionFilters'

export interface TransactionSessionFilters {
  statusTypeId: number | null
  blotterId: number | null
}

@Injectable({
  providedIn: 'root',
})
export class TransactionStateService {
  private _blotterId: number

  set blotterId(blotterId: number) {
    this._blotterId = blotterId
    sessionStorage.setItem('blotterId', '' + blotterId)
  }

  get blotterId() {
    if (this._blotterId) {
      return this._blotterId
    }
    const sessionBlotterId = Number(sessionStorage.getItem('blotterId'))
    if (sessionBlotterId) {
      this._blotterId = sessionBlotterId
    }
    return this._blotterId
  }

  getSessionFilters(): TransactionSessionFilters | null {
    try {
      const raw = sessionStorage.getItem(TRANSACTION_SESSION_FILTERS_KEY)
      return raw ? JSON.parse(raw) : null
    } catch {
      return null
    }
  }

  setSessionFilters(filters: TransactionSessionFilters) {
    try {
      sessionStorage.setItem(
        TRANSACTION_SESSION_FILTERS_KEY,
        JSON.stringify(filters),
      )
    } catch {
      // Storage unavailable (private mode / quota); the choice just isn't kept.
    }
  }

  clearSessionFilters() {
    try {
      sessionStorage.removeItem(TRANSACTION_SESSION_FILTERS_KEY)
    } catch {
      // Nothing to clear.
    }
  }
}
